import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { licenseService } from "../services/license.service";

const errMsg = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.detail || fallback;

export const fetchLicenses = createAsyncThunk(
  "license/fetchAll",
  async (_, thunkAPI) => {
    try {
      return await licenseService.getLicenses();
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch licenses");
    }
  }
);

export const fetchLicenseById = createAsyncThunk(
  "license/fetchById",
  async (id, thunkAPI) => {
    try {
      return await licenseService.getLicenseById(id);
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch license");
    }
  }
);

export const addLicense = createAsyncThunk(
  "license/add",
  async (license, thunkAPI) => {
    try {
      return await licenseService.createLicense(license);
    } catch (err) {
      return thunkAPI.rejectWithValue(errMsg(err, "Failed to create license"));
    }
  }
);

export const editLicense = createAsyncThunk(
  "license/edit",
  async ({ id, license }, thunkAPI) => {
    try {
      return await licenseService.updateLicense(id, license);
    } catch (err) {
      return thunkAPI.rejectWithValue(errMsg(err, "Failed to update license"));
    }
  }
);

export const removeLicense = createAsyncThunk(
  "license/remove",
  async (id, thunkAPI) => {
    try {
      // CHANGED: Now explicitly calls the soft delete endpoint
      await licenseService.softDeleteLicense(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to soft delete license");
    }
  }
);

const licenseSlice = createSlice({
  name: "license",
  initialState: {
    licenses: [],
    license: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLicenses.fulfilled, (state, action) => {
        state.loading = false;
        state.licenses = action.payload;
      })
      .addCase(fetchLicenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLicenseById.fulfilled, (state, action) => {
        state.license = action.payload;
      })
      .addCase(addLicense.fulfilled, (state, action) => {
        state.licenses.push(action.payload);
      })
      .addCase(editLicense.fulfilled, (state, action) => {
        const updated = action.payload;
        const targetId = updated.licenseId || updated.lisence_id;
        const index = state.licenses.findIndex(
          (l) => (l.licenseId || l.lisence_id) === targetId
        );
        if (index >= 0) state.licenses[index] = updated;
      })
      .addCase(removeLicense.fulfilled, (state, action) => {
        state.licenses = state.licenses.filter(
          (l) => (l.licenseId || l.lisence_id) !== action.payload
        );
      });
  },
});

export default licenseSlice.reducer;
